export default __webpack_public_path__ + "static/media/GR00025-disciple_medal_1.56a250bd.svg";